import React from "react";
import "./NewsLetter.css";

import { NewsLetterProps } from "../../../models/newsletter.model";
import { NewsLetterLayers } from "./NewsletterLayers";
import { NewsLetterSubscription } from "./NewsletterSubscription";

const NewsLetterPage: React.FC<NewsLetterProps> = ({ offset }) => (
	<div
		className="newsletter-container"
		style={{ "--offset": offset } as React.CSSProperties}
	>
		<NewsLetterLayers offset={offset} />
		<NewsLetterSubscription />
	</div>
);

export default NewsLetterPage;
